let pos_comp_BillSelectModal = require("../../templates/pos/comp/BillSelectModal.handlebars");
let pos_comp_BillSelectList = require("../../templates/pos/comp/BillSelectList.handlebars");
let Backbone = require("backbone");
let _ = require("underscore");
let BasePagingModel = require("../../model/BasePagingModel.js");

let main = function () {
    return Backbone.View.extend({

        events: {
            "click .pageUp": "onPrev",
            "click .pageDown": "onNext",
            "click .billSelectList li": "onSelectItem",
            "mouseover .billSelectList li": "onMouseOver",
            "mouseout .billSelectList li": "onMouseOut",
            "hidden.bs.modal": "onClose",
            'keyup': "key_onSelectItem"
        },

        initialize: function (params) {
            console.log('table select view params', params);
            this.model = new BasePagingModel(params);
            this.model.set({pageSize: 20});
        },

        /**
         * Triggered when modal closing
         */
        onClose: function () {
            this.trigger("closeSelect");
        },

        onPrev: function () {
            this.model.prev();
            this.renderBillList();
        },

        onNext: function () {
            this.model.next();
            this.renderBillList();
        },

        onMouseOver: function (evt) {
            $(evt.currentTarget).addClass("selected");
        },

        onMouseOut: function (evt) {
            $(evt.currentTarget).removeClass("selected");
        },

        onSelectItem: function (evt) {
            if ($(evt.currentTarget).hasClass("disabled")) {
                return false;
            }
            var moveBillItem = this.model.get("moveBillItem");
            var targetTable = this.model.get("targetTable");
            if ($(evt.currentTarget).hasClass("new-bill")) {
                this.$el.modal('hide');
                this.trigger("selectBill", null, moveBillItem, targetTable);
            } else {
                var billId = $(evt.currentTarget).data("id"),
                    bill = this.model.get("collection").get(billId);
                this.model.set({"currentBill": bill});
                this.$el.modal('hide');
                this.trigger("selectBill", this.model.get("currentBill"), moveBillItem, targetTable);
            }
            _.delay(_.bind(this.remove, this), 500);
        },

        key_onSelectItem: function (evt) {
            var status = $(".billSelectList").css("display");
            if (status == "block") {
                for (var i = 0; i < $(".billSelectList li").length; i++) {
                    var n = i + 97;
                    if (evt.keyCode == n) {
                        if ($(".billSelectList li").eq(i).hasClass("disabled")) {
                            return false;
                        }
                        var billId = $(".billSelectList li").eq(i).data("id"),
                            bill = this.model.get("collection").get(billId);
                        this.model.set({"currentBill": bill});
                        this.$el.modal('hide');
                        this.trigger("selectTable", this.model.get("currentBill"));
                        _.delay(_.bind(this.remove, this), 500);
                    }
                }
            }
        },

        render: function (bill) {
            $('.BillSelectListModal').remove();
            var currentBillSid = bill ? bill.get("sid") : "";
            this.setElement(pos_comp_BillSelectModal({
                currentBillSid: currentBillSid
            }));
            this.renderBillList();
            this.$el.modal();
            return this;
        },

        renderBillList: function () {
            let billJson = this.model.getPageCollection().toJSON();
            let table = this.model.get("targetTable").toJSON();
            this.$(".listContainer").html(pos_comp_BillSelectList({
                billList: billJson,
                table: table,
                disabledNext: this.model.hasNext(),
                disabledPrev: this.model.hasPrev()
            }));
        }
    });
};

let exportedValue = main();
export default exportedValue;


// WEBPACK FOOTER //
// ./src/view/comp/BillSelectModalView.js